import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useLayoutEffect, useMemo, useState } from "react";
import ApproveJobComponent from "./ApproveJobComponent";
import PropTypes from "prop-types";
import NotificationToaste from "../global/NotificationToaste";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MenuItem } from "react-pro-sidebar";
import { Delete } from "@mui/icons-material";
import ConfirmationDialog from "../global/ConfirmationDialog";
import LoadingBackDrop from "../global/LoadingBackDrop";
import { getPayload, setPayload } from "../../services/api";
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box justifyItems="center" sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ApproveJob = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(true);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [pendingsJobs, setPendingJobs] = useState([]);
  const [officers, setOfficers] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [data, setData] = useState([]);
  const [selectedRequestId, setSelectedRequestId] = useState();
  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleCloseDialog = () => {
    setOpenConfirmDialog(false);
  };
  useLayoutEffect(() => {
    loadBasicData();
  }, [message]);

  const loadBasicData = async () => {
    setLoading(true);

    await getPayload
      .getPayloadData("/labReq/all/pendingNewJobs")
      .then(function (response) {
        // console.log(response.data);
        setPendingJobs(response.data.pendingRequests);
        setOfficers(response.data.allUsers);
        setData(response.data.assignedRequests);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };
  const unAssignSelectedJob = async () => {
    console.log("object", selectedRequestId);
    setLoading(true);

    await setPayload
      .setPayloadData("/labReq/unAssign" + selectedRequestId.id)
      .then(function (response) {
        console.log(response.data);

        setPendingJobs(response.data.pendingRequests);
        setOfficers(response.data.allUsers);
        setData(response.data.assignedRequests);
        setLoading(false);

        setOpenConfirmDialog(false);
        setMessage(
          "Job : " +
            selectedRequestId.year +
            "/" +
            String(selectedRequestId.id).padStart(4, "0") +
            " Job completed successfully..!"
        );
        // setLoading(false);
        setMessageType("success");
        setOpen(true);
        loadBasicData();
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },
      {
        accessorKey: "regDate",
        header: "Date",
        size: 80,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 150,
      },
      {
        accessorFn: (row) =>
          `${row.grandTotal.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            muiTableHeadCellProps: {
              align: "right",
            },
            muiTableBodyCellProps: {
              align: "right",
            },
            muiTableFooterCellProps: {
              align: "right",
            },
          })}`,
        header: "Amount",
        size: 100,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        // backgroundColor:
        //   row.original.complete === true ? colors.greenAccent[800] : "#FAD02C",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          setSelectedRequestId(row.original);
          setOpenConfirmDialog(true);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Delete />}>
          <Typography variant="subtitle1">Remove Assign</Typography>
        </Button>
      </MenuItem>,
    ],
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}

      <Box sx={{ borderBottom: 1, borderColor: "divider" }} width="100%">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
        >
          <Tab
            sx={{ fontSize: "14px", fontWeight: 600 }}
            label="Pending Job Request"
            {...a11yProps(0)}
          />
          <Tab
            sx={{ fontSize: "14px", fontWeight: 600 }}
            label="Assigned Job Requests"
            {...a11yProps(1)}
          />
        </Tabs>

        <CustomTabPanel value={value} index={0} centered>
          <Paper
            sx={{
              padding: "15px",
              borderRadius: "8px",
              width: "95%",
            }}
            elevation={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Header title="Assigning Job" subtitle="New requests" />
              <Box
                sx={{
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                <Typography
                  color={colors.redAccent[500]}
                  alignContent="center"
                  variant="h3"
                ></Typography>
              </Box>
            </Box>
            {pendingsJobs?.map((data, index) =>
              data.paid === true ? (
                <ApproveJobComponent
                  key={index}
                  colors={colors}
                  isNonMobile={isNonMobile}
                  id={data.id}
                  year={data.year}
                  regDate={data.regDate}
                  project={data.project}
                  institute={data.institute}
                  contactNo={data.contactNo}
                  email={data.email}
                  grandTotal={data.grandTotal}
                  paid={data.paid}
                  officers={officers}
                  setOpen={setOpen}
                  setMessage={setMessage}
                  setMessageType={setMessageType}
                  data={data}
                  loading={loading}
                  setLoading={setLoading}
                  labTest={data.labRequestTests}
                />
              ) : (
                ""
              )
            )}
          </Paper>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1} centered>
          <Paper
            sx={{
              padding: "15px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header title="All assigned jobs" subtitle="Edit / Delete " />
            <Box display="flex" margin={1}></Box>
            <MaterialReactTable table={table} />
          </Paper>
        </CustomTabPanel>
      </Box>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
      <ConfirmationDialog
        confirmationMessage={
          "Are you sure that you need to unassign the selected job?"
        }
        openConfirmDialog={openConfirmDialog}
        handleCloseDialog={handleCloseDialog}
        messageTitle={"Complete Job"}
        dialogFunction={unAssignSelectedJob}
      />
    </Box>
  );
};

export default ApproveJob;
